import { fork, all } from 'redux-saga/effects'

import watchAuth from './auth'
import watchSystem from './system'
import watchUser from './user'
import watchLocalize from './localize'

export default function makeRootSaga(asyncSagas = {}, skipGlobal = false) {
  return function* rootSaga() {
    const globalSagas = [fork(watchAuth), fork(watchSystem), fork(watchLocalize), fork(watchUser)]

    const sagas = Object.values(asyncSagas)

    if (!skipGlobal) {
      sagas.push(...globalSagas)
    }

    yield all(sagas)
  }
}
